<template>
  <div id="smartTown">
    <div class="flex">
      <img
      src="@/assets/images/pic9.svg"
      style="width: 100%; height: auto"
      alt=""
    />
    </div>
      <div class="text">
应急处理系统针对突发公共卫生事件的管理，系统建设覆盖应急保障、监测分析、预测预警、应急处置、事件终止的全流程进行运行，循环反复不断提升系统的应急处理支持能力，实现“平战结合”，并能国家CDC或省级平台等相关系统进行数据交换，实现信息共享。 系统主体流程包括日常监测和预警、事件上报、应急处理、应急终止。应急处理包括应急响应、个案管理、任务管理、辅助决策等。      </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text{
    
  line-height: 24px;
  font-weight: 500;
    color: #666;
    margin-top: 30px;
    margin-right: 20px;
    text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/software14.vue